import { Box } from '@mui/material';

import { Skeleton } from 'shared/components/Skeleton';

import type { SkeletonProps as BaseSkeletonProps } from '@mui/material';
import type { FC } from 'react';

export const CellSkeleton: FC<BaseSkeletonProps> = props => (
  <Box>
    <Skeleton {...props} />
  </Box>
);
